export const noopFn =
  (contextName = "") =>
  () => {
    const prefix = contextName?.replace("Context","")
    console.warn(
      `${prefix}Provider is not a parent to this component. This function is a noop.`
    );
  };
